angular.module('zc.projects')

.directive 'zcCampaignRecentSegmentTable', (AccessStats) ->
  restrict: 'E'
  scope:
    campaign: '='
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_recent_segment_table.html'

  link: (scope, element, attrs) ->
    updateSegmentAccessStats = ->
      campaign_segment_id = scope.campaign.segment?.id or null

      device = AccessStats.handleCampaignDevice scope.campaign.campaign_device

      AccessStats.aggregate
        apikey: scope.campaign.apikey
        dimension: 'minutely'
      ,
        match:
          start_at:
            $gte: moment().subtract(1, 'hour').toDate()
          device: device
          campaign_segment_id: campaign_segment_id
          is_control: null
        pipeline: [
          $group:
            _id: null
            session_count:
              $sum: '$session_count'
            conversion_count:
              $sum: '$conversion_count'
        ]
      .then (access_stats) ->
        scope.segment = access_stats[0]

    scope.$watchGroup [
      'campaign.segment.name'
      'campaign.campaign_device'
      'campaign.campaign_target'
    ], updateSegmentAccessStats



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_recent_segment_table.directive.coffee